module.exports = __webpack_public_path__ + "static/media/06.9bd83e50.mp3";